import { WidgetVariantId } from 'api/services';

export const widgetVariantMap: Record<string, WidgetVariantId> = {
  episodeArtVariant: 'DV_ckr3u0go30000dip199xf5kd5',
  episodeTextVariant: 'DV_cldn7q2lg00010tqfeqgu26bi',
};
